<template lang="pug">
Page.advantage-company
    .advantage-company__top(
        slot="header"
    )
        h1.advantage-company__title
            | Преимущества компании

        .advantage-company__subheader
            SvInput.advantage-company__search(
                v-model="search"
                placeholder="Введите название преимущества"
                color="gray"
                size="large"
            )

            SvButton.advantage-company__add(
                view="big"
                text="Добавить"
                :prependIcon=`{
                    icon: 'plus',
                    width: 17,
                    height: 17,
                    fillDefault: '#fff',
                    fillHover: '#fff'
                }`
                @click="transfer('new')"
            )

    SvTable.advantage-company__table(
        :headers="fieldList"
        :body="list"
        :emptyText="emptyText"
        @transfer="(e) => transfer(e.id)"
    )
</template>

<script>
import { mapGetters } from 'vuex';
import { fields } from '@/config/advantagesCompany.js';
import Page from '@/layouts/page.vue';
import SvInput from '@/components/uikit/SvInput.vue';
import SvButton from '@/components/uikit/SvButton.vue';
import SvTable from '@/components/uikit/SvTable.vue';

export default {
  name: 'AdvantageCompany',

  beforeMount() {
    this.$store.dispatch('advantageCompany/getList');
  },

  computed: {
    ...mapGetters({
      list: 'advantageCompany/getList',
    }),

    fieldList () {
      return fields;
    },

    search: {
      get() {
        return this.$store.state.advantageCompany.search;
      },

      set(search) {
        this.$store.commit('advantageCompany/setSearch', search);
      },
    },

    emptyText () {
      return this.search ? 'Ничего не найдено' : 'Здесь пока ничего нет';
    },
  },

  methods: {
    transfer(id) {
      this.$router.push({
        name: 'advantages-company-edit',
        params: {
          id,
        },
      });
    },
  },


  components: {
    Page,
    SvInput,
    SvButton,
    SvTable,
  },
};
</script>

<style lang="scss" scoped>
.advantage-company {
  &__title {
    margin: 10px 0 19px 0;
    font-size: 46px;
    font-weight: 500;
    color: #404450;
  }

  &__subheader {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__search {
    width: 47%;
    min-width: 280px;
  }

  &__table {
    margin-top: 30px;
  }
}
</style>
